import { createContext, useMemo } from 'react'

import type { PairModel } from '../../atoms'
import type { ChildrenProps } from '@root/shared/react'

export const PairElementContext = createContext<{
  pair: PairModel | undefined
  useLinkForBadge: boolean
}>({
  useLinkForBadge: false,
  pair: undefined,
})

export const PairElementContextProvider = ({
  pair,
  useLinkForBadge,
  children,
}: {
  pair: PairModel | undefined
  useLinkForBadge: boolean
} & ChildrenProps) => {
  const contextValue = useMemo(
    () => ({ pair, useLinkForBadge }),
    [pair, useLinkForBadge],
  )

  return (
    <PairElementContext.Provider value={contextValue}>
      {children}
    </PairElementContext.Provider>
  )
}
